import { ARTIST_NAME, ARTIST_EMAIL, SPOTIFY_ALBUM_URL } from "./siteData";

export const Footer = () => (
  <footer data-testid="footer" className="py-12 px-6 bg-[#06070a] border-t border-[#161a29]">
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6 text-xs text-[#64748b]">
      <div className="flex items-center gap-3">
        <span className="font-disp font-bold uppercase text-white">{ARTIST_NAME}</span>
        <span>&bull;</span>
        <span>Sound Design Elettronico &amp; Colonne Sonore</span>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-6 font-mono-code">
        <a
          href={`mailto:${ARTIST_EMAIL}`}
          data-testid="footer-email-link"
          className="hover:text-white transition-colors"
        >
          {ARTIST_EMAIL}
        </a>
        <a
          href={SPOTIFY_ALBUM_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-spotify-link"
          className="hover:text-white transition-colors"
        >
          Spotify &bull; DistroKid
        </a>
        <a
          href="/press"
          data-testid="footer-presskit-link"
          className="hover:text-white transition-colors"
        >
          Press Kit
        </a>
        <span>&copy; Tutti i diritti riservati</span>
      </div>
    </div>
  </footer>
);
